var contactForm = (() => {
    function init() {
        window.addEventListener('DOMContentLoaded', () => {
            var slider = document.getElementById("range")
            var value = document.getElementById("range-value")
            value.innerHTML = parseFloat(slider.value).toFixed(1)

            // Update the current slider value (each time you drag the slider handle)
            if (slider) {
                slider.oninput = function () {
                    value.innerHTML = parseFloat(this.value).toFixed(1);
                }
            }

            let closeNotification = document.querySelector('#notification-close-btn');

            if (closeNotification) {
                closeNotification.addEventListener('click', (e) => {
                    e.preventDefault();
                    document.querySelector('.notification-overlay').classList.remove('active');
                });
            }
        })
    }

    return {
        init: init,
    }

})();

export default contactForm